import { useEffect, useRef } from "react";
import type { PackListConfig } from "../scenario/types";
import { ChoiceCard, ChoiceList } from "../ui/ChoiceCard";
import { audio } from "../lib/audio";

export function PackList({
  config,
  onChoose,
}: {
  config: PackListConfig;
  onChoose: (opt: PackListConfig["options"][number]) => void;
}) {
  const spoke = useRef(false);
  useEffect(() => {
    if (spoke.current) return;
    spoke.current = true;
    const line = config.body ?? "What should Max take for remote work today?";
    void audio.speak(line, { voice: config.voiceId ?? "onyx", lang: config.language ?? "en-US" });
    return () => audio.cancelSpeech();
  }, [config]);

  return (
    <div className="rw-panel packlist">
      <div className="rw-kicker">Remote work launch</div>
      <h2>{config.headline ?? "Pack for the trip"}</h2>
      {config.body && <p className="rw-body">{config.body}</p>}
      <ChoiceList prompt="What should Max take?">
        {config.options.map((o) => (
          <ChoiceCard
            key={o.id}
            category={o.category}
            showRiskLabel={false}
            reply={o.label}
            onClick={() => {
              const line = o.safe ? config.lenaSafe : config.lenaRisky;
              if (line) void audio.speak(line, { voice: "nova", lang: config.language ?? "en-US" });
              onChoose(o);
            }}
          />
        ))}
      </ChoiceList>
    </div>
  );
}
